<div class="flex flex-wrap mt-8 mb-6">

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
        @if ((myRoles$ |async)?.management) {
        <div class="flex gap-2 justify-center">
            <!-- @if (activeTab === 'lessons') {
            <app-btn-action label="New Lesson" (clicked)="onNewLesson()" bgColor="bg-primary-500"
                textColor="text-white" icon="fa fa-add"></app-btn-action>
            } -->
            @if (activeTab === 'sessions') {
            <app-btn-action label="New Session" (clicked)="onNewSession()" bgColor="bg-primary-500"
                textColor="text-white" icon="fa fa-add"></app-btn-action>
            <!-- TODO: Add option to add students in future releases -->
            <!-- } @if (activeTab === 'overview') {
            <app-btn-action label="Assign Students" (clicked)="showDragDrop = !showDragDrop"
                colors="{{showDragDrop ? 'bg-secondary-500' : 'bg-primary-500' }} text-white"
                icon="fas {{showDragDrop ? 'fa-toggle-off' : 'fa-toggle-on'}}"></app-btn-action> -->
            }
        </div>
        }
    </div>

    <div class="mb-2 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize text-primary-500">
            {{ grade?.gradeName }}
        </h1>
    </div>


    <div class="w-full">
        <!-- Tabs Navigation -->
        <div class="border-b border-gray-200">
            <nav class="flex space-x-4">
                <button type="button" (click)="setActiveTab('sessions')"
                    [class]="activeTab === 'sessions' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Sessions
                </button>
                <button type="button" (click)="setActiveTab('lessons')"
                    [class]="activeTab === 'lessons' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Lessons
                </button>
                <button type="button" (click)="setActiveTab('assignments')"
                    [class]="activeTab === 'assignments' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Assignments
                </button>
                <button type="button" (click)="setActiveTab('overview')"
                    [class]="activeTab === 'overview' ? 'border-secondary-500 text-secondary-600' : 'border-transparent text-gray-500'"
                    class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-0">
                    Overview
                </button>
            </nav>
        </div>

        <!-- Tab Content -->
        <div class="mt-6">
            <!-- Sessions Content -->
            @if (activeTab === 'sessions') {
            @let loadingSessions = (loadingSessions$ | async) ?? false;
            <div class="flex w-full flex-col gap-4">

                @for (item of sessions$ | async; track item.id) {
                <div class="bg-white shadow-lg rounded w-full px-4 py-3">
                    <a class="cursor-default flex flex-col gap-1">
                        <!-- [routerLink]="[ 'students', item.memberId]" -->
                        <div class="flex items-start justify-between flex-row w-full">
                            <div class="flex flex-col">
                                <p class="text-primary-300 text-xs whitespace-nowrap">
                                    {{ item.startDate.toDate() | moment: 'Do MMM YYYY hh:mm a' }}
                                </p>
                                <p class="font-semibold truncate text-nowrap">{{ item.sessionName }}</p>
                            </div>
                            <div class="flex flex-row gap-2 whitespace-nowrap">
                                <app-btn-fab (click)="onSessionAttendance(item)" icon="fas fa-person-circle-check"
                                    tooltip="Attendance"></app-btn-fab>
                                <app-btn-fab (click)="onEditSession(item)" icon="fas fa-edit"
                                    tooltip="Update Session"></app-btn-fab>
                                <app-btn-fab (click)="onDeleteSession(item)" icon="fa fa-trash-can"
                                    textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                            </div>
                        </div>
                        <p class="text-sm text-primary-400">Lesson: {{ item.lessonName }}</p>
                        <div class="flex items-center gap-2">
                            <div class="inline-block flex-none">
                                @if(item.teacherPhotoUrl) {
                                <img [src]="item.teacherPhotoUrl"
                                    class="min-h-8 max-h-8 max-w-8 min-w-8 bg-gray-100 object-cover rounded-full border-none" />
                                } @else {
                                <div
                                    class="bg-primary-100 uppercase text-primary-500 text-sm flex justify-center items-center text-center h-8 w-8 rounded-full">
                                    {{ item.teacherName | initials }}
                                </div>
                                }
                            </div>
                            <div class="flex-1 inline-flex flex-span text-sm text-blueGray-600">
                                <span>{{item.teacherName}}</span>
                            </div>
                        </div>
                    </a>
                </div>
                } @empty {
                @if(!loadingSessions) {
                <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
                    No Sessions Found
                </div>
                }
                }
                @if(loadingSessions) {
                <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
                    <div class="animate-pulse flex space-x-4">
                        <div class="flex-1 space-y-2">
                            <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                            <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                            <div class="space-y-2">
                                <div class="grid grid-cols-3 gap-4 mb-2">
                                    <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                                    <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                                </div>
                                <div class="flex flex-row gap-2 justify-start items-center">
                                    <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                                    <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
            <div class="flex flex-row w-full justify-center px-4 mt-3">
                <app-btn-more (click)="addMoreSessions()"
                    [isDisabled]="(loadingSessions$ | async) || user?.uid == null || groupId == null"></app-btn-more>
            </div>
            <!-- Lessons Content -->
            } @else if(activeTab === 'lessons') {
            @let loadingLessons = (loadingLessons$ | async) ?? false;
            <div class="flex w-full flex-col gap-4">

                @for (item of lessons$ | async; track item.id) {
                <div class="bg-white shadow-lg rounded flex flex-col gap-1 w-full px-4 py-3">
                    <div class="flex flex-row items-start justify-between gap-4 w-full">
                        <div [routerLink]="['lessons', item.id]" class="cursor-pointer flex flex-col justify-start">
                            <p class="text-primary-300 text-xs whitespace-nowrap">
                                {{ item.publishBy ?? item.created | moment: 'Do MMM YYYY hh:mm a' }}
                            </p>
                            <p class="font-semibold">{{ item.lessonName }}</p>
                        </div>
                        <div class="flex flex-row gap-2 whitespace-nowrap">
                            <app-btn-fab (click)="onDeleteLesson(item)" icon="fa fa-trash-can"
                                textColor="text-red-500 disabled:text-gray-200" tooltip="Delete"></app-btn-fab>
                        </div>
                    </div>
                    <div class="flex flex-row justify-start items-center gap-2 mt-2">
                        <p class="text-sm text-blueGray-600">{{item.createdBy}}</p>
                        <app-btn-chip [label]="item.lessonStatus ?? lessonStatus.open"
                            [color]="item.lessonStatus == lessonStatus.closed ? 'text-green-700' : 'text-primary-500'"
                            [bgColor]="item.lessonStatus == lessonStatus.closed ? 'bg-green-50' : 'bg-gray-100'"></app-btn-chip>
                    </div>
                </div>
                } @empty {
                @if(!loadingLessons) {
                <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
                    No Lessons Found
                </div>
                }
                }
                @if(loadingLessons) {
                <div class="bg-white shadow-lg rounded p-4 mt-1 w-full mx-auto">
                    <div class="animate-pulse flex space-x-4">
                        <div class="flex-1 space-y-2">
                            <div class="h-3 w-1/4 bg-slate-200 rounded"></div>
                            <div class="h-4 w-2/3 bg-slate-200 rounded"></div>
                            <div class="space-y-2">
                                <div class="grid grid-cols-3 gap-4 mb-2">
                                    <div class="h-4 bg-slate-200 rounded col-span-2"></div>
                                    <div class="h-4 bg-slate-200 rounded col-span-1"></div>
                                </div>
                                <div class="flex flex-row gap-2 justify-start items-center">
                                    <div class="h-6 w-6 bg-slate-200 rounded-full"></div>
                                    <div class="h-4 w-1/4 bg-slate-200 rounded"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
            <div class="flex flex-row w-full justify-center px-4 mt-3">
                <app-btn-more (click)="addMoreLessons()"
                    [isDisabled]="loadingLessons || user?.uid == null || groupId == null"></app-btn-more>
            </div>
            } @else if (activeTab === 'assignments') {
            <div>
                @if(grade?.id != null && grade?.id != 'unassigned') {
                <app-list-assignments id="assignments"></app-list-assignments>
                } @else {
                <div class="px-6 py-4 text-center font-semibold border-0 whitespace-nowrap">
                    No Assignments Found
                </div>
                }
            </div>
            } @else if (activeTab === 'overview') {
            <!-- Overview Content -->
            <div class="flex w-full mt-4 shadow-lg rounded bg-white p-4 flex-row flex-nowrap justify-between">
                <div class="flex flex-col">
                    <div class="w-full mb-1">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            Grade
                        </label>
                        <span class="text-blueGray-600 text-sm">{{grade?.gradeName}}</span>
                    </div>
                    <div class="w-full mb-1 mt-4">
                        <label class="block uppercase text-blueGray-600 text-xs font-bold">
                            Teacher
                        </label>
                        <span class="text-blueGray-600 text-sm">{{grade?.teacherName ?? 'Unassigned'}}</span>
                    </div>
                </div>
                <div class="flex flex-col justify-end">
                    <span class="text-blueGray-600 text-6xl font-bold text-right">{{group?.gradeStats?.[grade?.id ?? '']
                        ??
                        '-'}}</span>
                    <span class="text-blueGray-400 text-sm">Total Students</span>
                </div>
            </div>

            <div class="flex flex-row flex-nowrap justify-between">
                @if (showDragDrop) {
                <div
                    class="w-1/2 mr-2 p-4 rounded block overflow-x-auto mt-4 shadow-lg bg-white transform translate-x-full transition-transform duration-700 ease-out">
                    <div class="flex flex-col w-full">
                        <div class="w-full mb-1">
                            <label class="block uppercase text-blueGray-600 text-xs font-bold mb-1">
                                All Students
                            </label>
                        </div>
                        <form [formGroup]="searchForm" class="mb-4">
                            <div class="flex flex-row flex-nowrap w-full gap-2">
                                <input type="search" class="rounded grow" placeholder="Search Name">
                                <app-btn-submit actionText="Search" icon="fa fa-search" [isLoading]="isSearching"
                                    bgColor="bg-primary-500 active:bg-primary-200 disabled:bg-primary-200"></app-btn-submit>
                            </div>
                        </form>
                        @if (loadingStudents$ | async) {
                        <div class="flex flex-row justify-start place-items-center">
                            <div class="animate-pulse h-8 w-8 pr-8 bg-slate-200 rounded-full my-4"></div>
                            <div class="animate-pulse h-4 w-1/2 pr-8 bg-slate-200 rounded my-4 grow mb-2 ml-2">
                            </div>
                        </div>
                        } @else {
                        <div class="flex flex-col w-full rounded">
                            @for (item of allStudents; track $index) {
                            <div class="bg-white rounded flex flex-col mt-4">
                                <div class="flex flex-row items-center">
                                    <div class="inline-block flex-none">
                                        @if (item.photoURL) {
                                        <img [src]="item.photoURL"
                                            class="min-h-12 max-h-12 max-w-12 min-w-12 bg-gray-100 object-cover rounded-full border-none" />
                                        }
                                        @else {
                                        <div
                                            class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center h-12 w-12 rounded-full">
                                            {{ item.name | initials }}
                                        </div>
                                        }
                                    </div>
                                    <div class="flex flex-col px-3">
                                        <div class="flex-1 inline-flex flex-span text-sm font-bold text-blueGray-600">
                                            <span>{{item.name ?? ''}}</span>
                                        </div>
                                        <div class="flex flex-row gap-2 items-center">
                                            <p class="text-xs text-primary-300 capitalize font-light">{{item.gradeName
                                                ??
                                                'Unassigned'}}</p>
                                            <div class="bg-primary-300 rounded-full h-1 w-1"></div>
                                            <p class="text-xs text-primary-300 capitalize font-light">{{ item.status }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            } @empty {
                            <div class="px-6 py-4 text-sm text-center font-semibold border-0 whitespace-nowrap">
                                No data available
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>
                }

                <div
                    class="p-4 rounded block {{ showDragDrop ? 'w-1/2' : 'w-full' }} overflow-x-auto mt-4 shadow-lg bg-white">
                    <div class="flex flex-col w-full">
                        <div class="flex flex-row justify-between mb-2">
                            <label class="block uppercase text-blueGray-600 text-sm font-bold">
                                Grade Students
                            </label>
                            <button type="button" (click)="getAttendance()"
                                class="px-2 outline-none focus:outline-none focus:ring-0">
                                <i class="fas fa-refresh text-blueGray-300 hover:text-primary-500"></i></button>
                        </div>

                        @if (loadingStudents$ | async) {
                        <div class="flex flex-row justify-start place-items-center">
                            <div class="animate-pulse h-8 w-8 pr-8 bg-slate-200 rounded-full my-4"></div>
                            <div class="animate-pulse h-4 w-1/2 pr-8 bg-slate-200 rounded my-4 grow mb-2 ml-2"></div>
                        </div>
                        } @else {
                        <div class="flex flex-col w-full rounded">
                            @for (item of students$ | async; track $index) {
                            <div class="bg-white rounded flex flex-row justify-between mt-4">
                                <div class="flex flex-row items-center">
                                    <div class="inline-block flex-none">
                                        @if (item.photoURL) {
                                        <img [src]="item.photoURL"
                                            class="min-h-12 max-h-12 max-w-12 min-w-12 bg-gray-100 object-cover rounded-full border-none" />
                                        }
                                        @else {
                                        <div
                                            class="bg-primary-100 uppercase text-primary-500 text-base flex justify-center items-center text-center h-12 w-12 rounded-full">
                                            {{ item.name | initials }}
                                        </div>
                                        }
                                    </div>
                                    <div class="flex flex-col px-3">
                                        <div class="flex-1 inline-flex flex-span text-sm font-bold text-blueGray-600">
                                            <span>{{item.name ?? ''}}</span>
                                        </div>
                                        <div class="flex flex-row gap-2 items-center">
                                            <p class="text-xs text-primary-300 capitalize font-light">{{item.gradeName
                                                ??
                                                'Unassigned'}}</p>
                                            <div class="bg-primary-300 rounded-full h-1 w-1"></div>
                                            <p class="text-xs text-primary-300 capitalize font-light">{{ item.status }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="min-w-16 flex items-center"><app-progress-determinate
                                        [progress]="attendanceMap?.[item.memberId] || 0">
                                    </app-progress-determinate>
                                </div>
                            </div>
                            } @empty {
                            <div class="px-6 py-4 text-sm text-center font-semibold border-0 whitespace-nowrap">
                                No data available
                            </div>
                            }
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="flex flex-row w-full justify-center px-4 mt-3">
                <app-btn-more (click)="addMoreStudents()"
                    [isDisabled]="((loadingStudents$ | async) ?? false) || user?.uid == null || groupId == null"></app-btn-more>
            </div>
            }
        </div>
    </div>
</div>